'use client';

import { useEffect, useState } from 'react';
import confetti from 'canvas-confetti';

const BIRTHDAY_DATE = { month: 4, day: 19, year: 2026 }; // April 19, 2026

function isBirthdayToday(): boolean {
  const now = new Date();
  return (
    now.getFullYear() === BIRTHDAY_DATE.year &&
    now.getMonth() + 1 === BIRTHDAY_DATE.month &&
    now.getDate() === BIRTHDAY_DATE.day
  );
}

export default function BirthdayAnimation() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isBirthdayToday()) return;

    setVisible(true);

    // Firecracker burst sequence
    const fireBurst = () => {
      const count = 200;
      const defaults = { origin: { y: 0.6 } };

      confetti({
        ...defaults,
        particleCount: count,
        spread: 120,
        startVelocity: 55,
        colors: ['#ff6b6b', '#ffd93d', '#6bcb77', '#4d96ff', '#ff922b', '#cc5de8'],
      });

      confetti({
        ...defaults,
        particleCount: count / 2,
        spread: 80,
        startVelocity: 45,
        origin: { x: 0.2, y: 0.7 },
        colors: ['#ff6b6b', '#ffd93d', '#6bcb77'],
      });

      confetti({
        ...defaults,
        particleCount: count / 2,
        spread: 80,
        startVelocity: 45,
        origin: { x: 0.8, y: 0.7 },
        colors: ['#4d96ff', '#ff922b', '#cc5de8'],
      });
    };

    // Initial burst
    fireBurst();

    // Repeat bursts
    const interval = setInterval(fireBurst, 1500);

    // Auto-close after 6 seconds
    const closeTimer = setTimeout(() => {
      clearInterval(interval);
      setVisible(false);
    }, 6000);

    return () => {
      clearInterval(interval);
      clearTimeout(closeTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.88)' }}
      onClick={() => setVisible(false)}
    >
      <div className="text-center px-8 select-none pointer-events-none">
        <div
          className="text-5xl md:text-7xl font-extrabold text-white mb-4 leading-tight"
          style={{
            textShadow: '0 0 30px rgba(255, 215, 0, 0.8), 0 0 60px rgba(255, 165, 0, 0.5)',
            animation: 'birthdayPulse 1s ease-in-out infinite alternate',
          }}
        >
          🎉 Happy Birthday Vinoth 🎉
        </div>
        <p className="text-yellow-300 text-lg md:text-xl mt-4 opacity-80">
          Wishing you a wonderful day! 🎂
        </p>
        <p className="text-white/40 text-sm mt-8">Click anywhere to close</p>
      </div>

      <style jsx>{`
        @keyframes birthdayPulse {
          from { transform: scale(1); }
          to { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );
}
